__turbopack_context__.v({
  "actionsRow": "PrecisionTest-module__xlCZja__actionsRow",
  "body": "PrecisionTest-module__xlCZja__body",
  "clicksLabel": "PrecisionTest-module__xlCZja__clicksLabel",
  "feedback": "PrecisionTest-module__xlCZja__feedback",
  "info": "PrecisionTest-module__xlCZja__info",
  "isActive": "PrecisionTest-module__xlCZja__isActive",
  "isFilled": "PrecisionTest-module__xlCZja__isFilled",
  "isSuccess": "PrecisionTest-module__xlCZja__isSuccess",
  "isSuccessDot": "PrecisionTest-module__xlCZja__isSuccessDot",
  "precision-pulse": "PrecisionTest-module__xlCZja__precision-pulse",
  "progressDot": "PrecisionTest-module__xlCZja__progressDot",
  "progressDots": "PrecisionTest-module__xlCZja__progressDots",
  "result-failed": "PrecisionTest-module__xlCZja__result-failed",
  "result-success": "PrecisionTest-module__xlCZja__result-success",
  "runner": "PrecisionTest-module__xlCZja__runner",
  "runnerDanger": "PrecisionTest-module__xlCZja__runnerDanger",
  "runnerSuccess": "PrecisionTest-module__xlCZja__runnerSuccess",
  "shell": "PrecisionTest-module__xlCZja__shell",
  "status-failed": "PrecisionTest-module__xlCZja__status-failed",
  "status-initial": "PrecisionTest-module__xlCZja__status-initial",
  "status-success": "PrecisionTest-module__xlCZja__status-success",
  "statusPill": "PrecisionTest-module__xlCZja__statusPill",
  "targetRing": "PrecisionTest-module__xlCZja__targetRing",
  "wrapper": "PrecisionTest-module__xlCZja__wrapper",
});
